import React from "react"
import styled from "styled-components"
import theme from "@src/styles/theme"
import Image from "@src/components/core-image"
import PropTypes from "prop-types"

const MoreLink = styled.a`
  text-decoration: none;
`

const DifficultyCardWrapper = styled.div`
  border-radius: 8px;
  border: 0.993px solid #dfdfdf;
  background: ${theme.whiteShade};
  min-height: 479px;
  width: calc(33.38% - 22px);
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 24px;

  @media (max-width: 1000px) {
    width: calc(50% - 16px);
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`

const LevelRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
`
const Level = styled.div`
  color: ${theme.secondary500};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
`

const Description = styled.div`
  color: ${theme.blackShade};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-bottom: auto;
`

const LevelBold = styled(Description)`
  display: inline-block;
  font-weight: 700;
`
const More = styled.div`
  color: ${theme.link};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.25px;
  cursor: pointer;
`

const DifficultyCard = ({
  link,
  image,
  level,
  description,
  descriptionBold,
  cta,
}) => {
  return (
    <DifficultyCardWrapper>
      <LevelRow>
        <Image src={image} alt="rating" />
        <Level>{level}</Level>
      </LevelRow>
      <Description>
        <LevelBold>{descriptionBold}</LevelBold> {description}
      </Description>
      <MoreLink href={link} target="_blank">
        <More>{cta} ➝</More>
      </MoreLink>
    </DifficultyCardWrapper>
  )
}

DifficultyCard.propTypes = {
  image: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  descriptionBold: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,

  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}

export default DifficultyCard
